import onVisible, {
  renderElements,
  renderAll,
  renderAllAnimationFrame,
  renderRequired,
  hasListener,
  removeListener,
  removeAllListeners
} from './onVisible'

export {
  onVisible,
  renderElements,
  renderAll,
  renderAllAnimationFrame,
  renderRequired,
  hasListener,
  removeListener,
  removeAllListeners
}

if ('undefined' !== typeof window && !window['$onVisible']) {
  window['$onVisible'] = {
    render: onVisible,
    renderElements,
    renderAll,
    renderAllAnimationFrame,
    renderRequired,
    hasListener,
    removeListener,
    removeAllListeners
  }
}
